<div class="control">
  <div
    class="color-picker-wrapper"
    [ngClass]="{ 'is-danger': showErrors && form.invalid }"
  >
    <label
      >{{ label }}<span class="required-indicator has-text-danger" *ngIf="required">*required</span></label
    >

    <div
      class="circle"
      [ngStyle]="{ background: selectedColor }"
      (click)="showList = !showList"
    ></div>

    <div class="card block color-list px-4 pt-6 pb-4" *ngIf="showList">
      <label class="full-width ml-3">Select a color</label>

      <div
        class="small-circle"
        (click)="select(color)"
        *ngFor="let color of colors"
        [ngStyle]="{ background: color }"
        [ngClass]="{ 'is-active': color === selectedColor }"
      ></div>
    </div>
  </div>
  <p class="help mb-1" *ngIf="helpText">{{ helpText }}</p>
</div>
